import './Empty.scss'
import React from 'react'
import { Empty } from 'antd'
import { images } from '../../config/images'

const CustomizeRenderEmpty = ({ setDataSource, inputRef }) => {
  return (
    <div className="Empty">
      <Empty
        image={images.Empty}
        imageStyle={{
          height: 300,
        }}
        description={
          <p>No results found. Try searching with another Invoice number</p>
        }
      >
      </Empty>
    </div>
  )
}

export default CustomizeRenderEmpty
